import axios from 'axios';

const baseApiUrl = 'api/organization-requests';

export default class RequestsPreviewService {
  public getServiceRequests(
    filter: string = 'outgoing',
    page: number = 0,
    size: number = 20,
    sort: string = 'lastActivityDate,desc'
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/services`, {
          params: {
            filter,
            page,
            size,
            sort,
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getInfrastructureRequests(
    filter: string = 'outgoing',
    page: number = 0,
    size: number = 20,
    sort: string = 'lastActivityDate,desc'
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/infrastructures`, {
          params: {
            filter,
            page,
            size,
            sort,
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
